// extracted by mini-css-extract-plugin
module.exports = {"ExpedientDetailsWrapper":"ExpedientConsultation_ExpedientDetailsWrapper__1KPM2","primaryCardWrapper":"ExpedientConsultation_primaryCardWrapper__6qbQ0"};